import React from "react";

const GalleryHoverLayer = () => {
  return (
    <>
      <div className='mt-24 card h-100 p-0 radius-12 overflow-hidden gallery-scale'>
        <div className='card-header'>
          <h6 className='mb-0'>Hover Effect 1</h6>
        </div>
        <div className='card-body p-24'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img1.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img1.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img2.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img2.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img3.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img3.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img4.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img4.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24 card h-100 p-0 radius-12 overflow-hidden gallery-scale'>
        <div className='card-header'>
          <h6 className='mb-0'>Hover Effect 2</h6>
        </div>
        <div className='card-body p-24'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-two border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img5.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img5.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-two border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img6.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img6.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-two border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img7.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img7.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-two border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img8.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img8.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24 card h-100 p-0 radius-12 overflow-hidden gallery-scale'>
        <div className='card-header'>
          <h6 className='mb-0'>Hover Effect 3</h6>
        </div>
        <div className='card-body p-24'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-three border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img9.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img9.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-three border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img10.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img10.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-three border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img11.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img11.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-three border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img12.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img12.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24 card h-100 p-0 radius-12 overflow-hidden gallery-scale'>
        <div className='card-header'>
          <h6 className='mb-0'>Hover Effect 4</h6>
        </div>
        <div className='card-body p-24'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-four border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img1.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img1.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-four border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img2.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img2.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-four border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img3.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img3.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-four border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img4.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img4.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24 card h-100 p-0 radius-12 overflow-hidden gallery-scale'>
        <div className='card-header'>
          <h6 className='mb-0'>Hover Effect 5</h6>
        </div>
        <div className='card-body p-24'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-five border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img5.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img5.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-five border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img6.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img6.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-five border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img7.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img7.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-five border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img8.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img8.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24 card h-100 p-0 radius-12 overflow-hidden gallery-scale'>
        <div className='card-header'>
          <h6 className='mb-0'>Hover Effect 6</h6>
        </div>
        <div className='card-body p-24'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-six border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img9.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img9.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-six border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img10.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img10.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-six border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img11.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img11.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-six border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img12.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img12.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24 card h-100 p-0 radius-12 overflow-hidden gallery-scale'>
        <div className='card-header'>
          <h6 className='mb-0'>Hover Effect 7</h6>
        </div>
        <div className='card-body p-24'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-seven border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img1.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img1.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-seven border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img2.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img2.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-seven border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img3.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img3.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-seven border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img4.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img4.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24 card h-100 p-0 radius-12 overflow-hidden gallery-scale'>
        <div className='card-header'>
          <h6 className='mb-0'>Hover Effect 8</h6>
        </div>
        <div className='card-body p-24'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-eight border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img5.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img5.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-eight border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img6.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img6.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-eight border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img7.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img7.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-eight border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img8.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img8.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-24 card h-100 p-0 radius-12 overflow-hidden gallery-scale'>
        <div className='card-header'>
          <h6 className='mb-0'>Hover Effect 9</h6>
        </div>
        <div className='card-body p-24'>
          <div className='row gy-4'>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-nine border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img9.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img9.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-nine border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img10.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img10.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-nine border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img11.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img11.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
            <div className='col-xxl-3 col-md-4 col-sm-6'>
              <div className='hover-scale-img style-nine border radius-16 overflow-hidden p-8'>
                <a
                  href='assets/images/gallery/gallery-img12.png'
                  className='popup-img w-100 h-100 d-flex radius-12 overflow-hidden'
                >
                  <img
                    src='assets/images/gallery/gallery-img12.png'
                    alt=''
                    className='hover-scale-img__img w-100 h-100 object-fit-cover'
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GalleryHoverLayer;
